import { SubscriptionItemType } from "@/primary-models";

export type Product =
  | "NIBBLES_SALMON"
  | "NIBBLES_CHICKEN"
  | "NIBBLES_SALMON_POUCH"
  | "NIBBLES_CHICKEN_POUCH"
  | "NIBBLES_TUNA_POUCH"
  | "SPRINKLES"
  | "CLUCK"
  | "BAAA"
  | "QUACK"
  | "GOBBLE"
  | "MOOO"
  | "OINK"
  | "SPLASH"
  | "SHREDDED_CLUCK"
  | "SHREDDED_GOBBLE"
  | "SWISH"
  | "SMOOTH_PECK"
  | "SMOOTH_CLUCK"
  | "BUBBLE_AND_QUACK"
  | "TOFU_SCOOP"
  | "PLANET_SCOOP"
  | "HEALTH_SCOOP"
  | "POUCH_CHICKEN"
  | "POUCH_TURKEY"
  | "POUCH_BEEF"
  | "CLUCK_2404"
  | "GOBBLE_2404"
  | "QUACK_2404"
  | "OINK_2404"
  | "SPLASH_2404"
  | "BAAA_2404"
  | "MOOO_2404";

export type ExtraProduct = "TOFU_SCOOP_LITTER"
| "HEALTH_SCOOP_LITTER"
| "PLANET_SCOOP_LITTER";

export type TProductTypeLitter = Extract<ExtraProduct, "HEALTH_SCOOP_LITTER" | "PLANET_SCOOP_LITTER">;

export type RecipeProductTitle = Extract<Product, "BAAA" | "CLUCK" | "MOOO" | "SPLASH" | "GOBBLE" | "QUACK" | "OINK" | "SHREDDED_CLUCK" | "SHREDDED_GOBBLE" | "SWISH" | "SMOOTH_PECK" | "SMOOTH_CLUCK">;
export type ExtraProductTitle = Extract<Product, "SPRINKLES" | "NIBBLES_CHICKEN" | "NIBBLES_SALMON" | "NIBBLES_SALMON_POUCH" | "NIBBLES_CHICKEN_POUCH" | "NIBBLES_TUNA_POUCH">;
export const RECIPE_PRODUCT_TITLES = [ "BAAA", "CLUCK", "MOOO", "SPLASH", "GOBBLE", "QUACK", "OINK", "SHREDDED_CLUCK", "SHREDDED_GOBBLE", "SWISH", "SMOOTH_PECK", "SMOOTH_CLUCK" ] satisfies RecipeProductTitle[];
export const EXTRA_PRODUCT_TITLES = [ "SPRINKLES", "NIBBLES_CHICKEN", "NIBBLES_SALMON", "NIBBLES_CHICKEN_POUCH", "NIBBLES_SALMON_POUCH", "NIBBLES_TUNA_POUCH" ] satisfies ExtraProductTitle[];

export const RECIPE_TITLE_MAP: Record<string, RecipeProductTitle> = {
  Baaa: "BAAA",
  "Baaa!": "BAAA",
  "2404 Baaa!": "BAAA",
  Cluck: "CLUCK",
  "Cluck!": "CLUCK",
  "2404 Cluck!": "CLUCK",
  "Pouch Chicken!": "CLUCK",
  Mooo: "MOOO",
  "Mooo!": "MOOO",
  "2404 Mooo!": "MOOO",
  "Pouch Beef!": "MOOO",
  Splash: "SPLASH",
  "Splash!": "SPLASH",
  "2404 Splash!": "SPLASH",
  Gobble: "GOBBLE",
  "Gobble!": "GOBBLE",
  "2404 Gobble!": "GOBBLE",
  "Pouch Turkey!": "GOBBLE",
  Quack: "QUACK",
  "Quack!": "QUACK",
  "2404 Quack!": "QUACK",
  "Pouch Duck!": "QUACK",
  "Bubble and Quack!": "QUACK",
  Oink: "OINK",
  "Oink!": "OINK",
  "2404 Oink!": "OINK",
  Swish: "SWISH",
  "Swish!": "SWISH",
  "Smooth Peck": "SMOOTH_PECK",
  "Smooth Peck!": "SMOOTH_PECK",
  "Smooth Cluck": "SMOOTH_CLUCK",
  "Smooth Cluck!": "SMOOTH_CLUCK",
};

export const RECHARGE_PRODUCT_TO_SUBSCRIPTION_ITEM_TYPE: Record<string, SubscriptionItemType> = {
  ...RECIPE_TITLE_MAP,
  "Nibbles Chicken": "NIBBLES_CHICKEN",
  "Nibbles Salmon": "NIBBLES_SALMON",
  Sprinkles: "SPRINKLES",
  "Health Scoop": "SCOOP_HEALTH",
  "Planet Scoop": "SCOOP_PLANET",
  "Tote bag": "TOTE_BAG",
};
